//src/components/Navbar.jsx
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import API from "../services/api";

const Navbar = () => {
  const navigate = useNavigate();

  const [user, setUser] = useState(null);
  const [open, setOpen] = useState(false);

  const token = localStorage.getItem("token");

  const handleLogout = () => {
    localStorage.removeItem("token");
    setUser(null); // ✅ clear user immediately
    setOpen(false); // ✅ close dropdown
    navigate("/login");
  };


  const navLinkStyle = {
    color: "#111827",
    textDecoration: "none",
    fontWeight: 600,
    fontSize: 14,
    padding: "8px 12px",
    borderRadius: 12,
    border: "1px solid transparent",
  };
  
  const DropdownItem = ({ children, onClick }) => (
    <div
      onClick={onClick}
      style={{
        padding: "12px 14px",
        cursor: "pointer",
        borderBottom: "1px solid #f3f4f6",
        fontWeight: 500,
        color: "#111827",
        background: "#fff",
      }}
      onMouseOver={(e) =>
        (e.currentTarget.style.background =
          "#f9fafb")
      }
      onMouseOut={(e) =>
        (e.currentTarget.style.background =
          "#fff")
      }
    >
      {children}
    </div>
  );

  // =========================
  // FETCH USER
  // =========================
  useEffect(() => {
    const fetchUser = async () => {
      if (!token) {
        setUser(null); // ✅ ensure logged out state
        return;
      }

      try {
        const res = await API.get("/auth/me", {
          headers: { Authorization: `Bearer ${token}` },
        });

        setUser(res.data);
      } catch (err) {
        console.error(err);
        setUser(null); // ✅ fallback if token invalid
      }
    };

    fetchUser();
  }, [token]);

  const displayName =
    user?.username ||
    user?.email?.split("@")[0] ||
    "User";

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "14px 24px",
        background: "#fff",
        borderBottom: "1px solid #eee",
        fontFamily: "Inter, sans-serif",
      }}
    >
      {/* LOGO */}
      <div
        onClick={() => navigate("/dashboard")}
        style={{
          display: "flex",
          alignItems: "center",
          gap: 10,
          cursor: "pointer",
        }}
      >
        <img src="/logo.png" alt="Creator Yard" style={{ width: 34, height:34, borderRadius:10, }} />
        <span 
          style={{ 
            fontWeight: "900", 
            fontSize:18, 
            color:"#111827", 
          }}
        >
          Creator {" "}
          <span style={{ color: "#22c55e" }}>
          
            -Yard
          </span>
        </span>
      </div>

      {/* NAV */}
      <div 
        style={{ 
          display: "flex", 
          gap: 20, 
          alignItems: "center" 
        }}
      >
        
        {/* ✅ LOGGED IN */}
        {user ? (
          <>
            <Link 
              to="/studio"
              style={navLinkStyle}
            >
              My studio
            </Link>

            {/* 👤 USER DROPDOWN */}
            <div style={{ position: "relative" }}>
              <div
                onClick={() => setOpen(!open)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  cursor: "pointer",
                  fontWeight: "600",
                  color: "#111827",
                  background: "#f9fafb",
                  padding: "10px 14px",
                  borderRadius: 14,
                  border: "1px solid #e5e7eb",
                }}
              >
                👤 {displayName}
              </div>

              {open && (
                <div
                  style={{
                    position: "absolute",
                    top: 50,
                    right: 0,
                    background: "#fff",
                    border: "1px solid #e5e7eb",
                    borderRadius: 16,
                    boxShadow: "0 5px 40px rgba(0,0,0,0.08)",
                    overflow: "hidden",
                    Width: 2000,
                    zIndex: 10,
                  }}
                >
                  <DropdownItem
                    onClick={() => navigate("/studio")}
                  >
                     Profile
                  </DropdownItem>

                  <DropdownItem
                    onClick={() => navigate("/withdraw")}
                  >
                    💰 Withdraw
                  </DropdownItem>

                  {/* 🔥 ADMIN ONLY */}
                  {user?.is_admin && (
                    <>
                      <DropdownItem
                        onClick={() => navigate("/admin/withdraw")}
                      >
                        🧑‍💼 Admin Withdraw
                      </DropdownItem>

                      <DropdownItem
                        onClick={() => navigate("/admin/contest")}
                      >
                        🧑‍💼 Admin contest
                      </DropdownItem>
                    </>
                  )}

                  <div
                    onClick={handleLogout}
                    style={{
                      padding:"12px 14px",
                      cursor: "pointer",
                      borderTop:
                        "1px solid #f3f4f6",
                      color: "ef4444",
                      fontWeight: "600",
                    }}
                  >
                    🚪 Logout
                  </div>
                </div>
              )}
            </div>
          </>
        ) : (
          /* ❌ LOGGED OUT */
          <>
            
            <Link 
              to="/login"
              style = {navLinkStyle}
            >
              Login
            </Link>
            
            <Link 
              to="/signup"
              style={{
                background: "#f97316",
                color: "#fff",
                padding: "10px 14px",
                borderRadius: 14,
                fontWeight: 700,
                textDecoratiom: "none",
                boxShadow: "0 10px 25px rgba(249,115,22,0.25)",
                
              }}
            >
              Signup
            </Link>
          </>
        )}
      </div>
    </div>
  );
};



export default Navbar;